


















import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyList from '@/mixins/list';

@Component
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = 'stadium/roles';

  columns: any[] = [
    { title: '编号', dataIndex: 'id' },
    { title: '角色名称', dataIndex: 'role_name' },
    { title: '操作', scopedSlots: { customRender: 'action' } },
  ];

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
